import { useIsMounted, useUnmountEffect } from "@react-hookz/web";
import { useRef } from "react";

/**
 * This state and function pair is used to reset the selection in cases where we have selected
 * a "utility" option like "select all" or "create X". When those are selected, we need to
 * clear that selection out so downshift doesn't get confused about what is selected.
 *
 * See its usages for more comments on how it's used!
 *
 * @param selectItem the selectItem function from downshift.
 */
export var useResetSelection = function useResetSelection() {
  var selectionCleanupTimeout = useRef(-1);
  useUnmountEffect(function () {
    window.clearTimeout(selectionCleanupTimeout.current);
  });
  var getIsMounted = useIsMounted();
  return {
    /**
     * @param selectItem The function from downshift to set the selected value of the component.
     * @param timeout The number of millis to wait before the reset. This is specific to
     *      each call and is gleaned from the downshift source code. This whole thing is
     *      such a hack.
     */
    resetSelection: function resetSelection(selectItem, timeout) {
      window.clearTimeout(selectionCleanupTimeout.current);
      selectionCleanupTimeout.current = window.setTimeout(function () {
        // This can only be called if the component is still mounted.
        // Thanks React dev warnings!
        if (getIsMounted()) {
          selectItem(null);
        }
      }, timeout);
    }
  };
};
//# sourceMappingURL=useResetSelection.js.map